import { cmsApi } from "../base/cmsApi";



interface UseMutateApiType {
    Service?: "CMS_PROC";
}

const useMutateApi = ({
    Service
}: UseMutateApiType) => {

    function _api() {
        switch (Service) {
            case "CMS_PROC":
                return cmsApi;
            default:
                return cmsApi;
        }
    }

    async function _fileUploadApi(url: string, formData: FormData) {
        try {
            return _api().post(url, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });
        } catch (error: any) {
            throw error;
        }
    }

    const _post = async (url: string, data: any) => {
        try {
            const response = await _api().post(url, data);
            return response.data;
        } catch (error: any) {
            throw error;
        }
    }

    const _put = async (url: string, data: any) => {
        try {
            const response = await _api().put(url, data);
            return response.data;
        } catch (error: any) {
            throw error;
        }
    }

    const _delete = async (url: string) => {
        try {
            const response = await _api().delete(url);
            return response.data;
        } catch (error: any) {
            throw error;
        }
    }

    const _get = async (url: string) => {
        try {
            const response = await _api().get(url);
            return response.data;
        } catch (error: any) {
            throw error;
        }
    }

    const _patch = async (url: string) => {
        try {
            const response = await _api().patch(url);
            return response.data;
        } catch (error: any) {
            throw error;
        }
    }

    return {
        _post,
        _put,
        _delete,
        _get,
        _patch,
        _fileUploadApi,
        _api
    }
}

export { useMutateApi };